var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        title: "记账凭证",
        width: 1120,
        visible: _vm.visible,
        footer: null,
        maskClosable: false,
      },
      on: { cancel: _vm.close },
    },
    [
      _vm.visible
        ? _c(
            "div",
            { ref: "voucherEditorRef", staticClass: "voucher-editor" },
            [
              _c(
                "div",
                {
                  staticClass: "h-row-flex top-buttons",
                  staticStyle: { "margin-bottom": "12px" },
                },
                [
                  _c("div", { staticClass: "h-col" }, [
                    _vm.isEdit
                      ? _c(
                          "button",
                          {
                            staticClass: "h-btn h-btn-primary",
                            attrs: { type: "button", disabled: _vm.saving },
                            on: {
                              click: function ($event) {
                                return _vm.save(false)
                              },
                            },
                          },
                          [_c("span", [_vm._v("保存并新增")])]
                        )
                      : _vm._e(),
                    _vm.isEdit
                      ? _c(
                          "button",
                          {
                            staticClass: "h-btn h-btn-primary",
                            staticStyle: { "margin-left": "8px" },
                            attrs: { type: "button", disabled: _vm.saving },
                            on: {
                              click: function ($event) {
                                return _vm.save(true)
                              },
                            },
                          },
                          [_c("span", [_vm._v("保存")])]
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
              _c(
                "div",
                { staticClass: "h-row-flex voucher-head" },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { "min-width": "70px", width: "70px" },
                      model: {
                        value: _vm.form.voucherWordId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "voucherWordId", $$v)
                        },
                        expression: "form.voucherWordId",
                      },
                    },
                    _vm._l(_vm.voucherWords, function (w) {
                      return _c(
                        "a-select-option",
                        { key: w.id, attrs: { value: w.id } },
                        [_vm._v(_vm._s(w.word))]
                      )
                    }),
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "min-width": "90px",
                        display: "inline-block",
                        "text-align": "center",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.form.voucherNoNum
                            ? _vm.form.voucherNoNum + " 号"
                            : "自动"
                        )
                      ),
                    ]
                  ),
                  _c("span", { staticStyle: { "margin-left": "12px" } }, [
                    _vm._v("日期："),
                  ]),
                  _c("a-date-picker", {
                    staticStyle: { width: "140px" },
                    attrs: { format: "YYYY-MM-DD" },
                    model: {
                      value: _vm.form.voucherDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "voucherDate", $$v)
                      },
                      expression: "form.voucherDate",
                    },
                  }),
                  _c("span", { staticStyle: { "margin-left": "12px" } }, [
                    _vm._v("备注："),
                  ]),
                  _c("a-input", {
                    staticStyle: { width: "300px" },
                    attrs: { placeholder: "请输入备注内容" },
                    model: {
                      value: _vm.form.summary,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "summary", $$v)
                      },
                      expression: "form.summary",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "voucher-table bg-white-color" }, [
                _c("table", { attrs: { cellspacing: "0", cellpadding: "0" } }, [
                  _c("thead", [
                    _c("tr", { staticClass: "bg-white-color" }, [
                      _c(
                        "td",
                        {
                          staticClass: "td-zhaoyao-head",
                          staticStyle: { "font-weight": "bold" },
                        },
                        [_vm._v("摘要")]
                      ),
                      _c(
                        "td",
                        {
                          staticClass: "td-kemu-head",
                          staticStyle: { "font-weight": "bold" },
                        },
                        [_vm._v("会计科目")]
                      ),
                      _c("td", { staticClass: "td-money-head" }, [
                        _c("div", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v("借方金额"),
                        ]),
                        _c("div", { staticClass: "moneyUnit" }, [
                          _c("span", [_vm._v("亿")]),
                          _c("span", [_vm._v("千")]),
                          _c("span", [_vm._v("百")]),
                          _c("span", [_vm._v("十")]),
                          _c("span", [_vm._v("万")]),
                          _c("span", [_vm._v("千")]),
                          _c("span", [_vm._v("百")]),
                          _c("span", [_vm._v("十")]),
                          _c("span", [_vm._v("元")]),
                          _c("span", [_vm._v("角")]),
                          _c("span", { staticClass: "last" }, [_vm._v("分")]),
                        ]),
                      ]),
                      _c("td", { staticClass: "td-money-head tdLast" }, [
                        _c("div", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v("贷方金额"),
                        ]),
                        _c("div", { staticClass: "moneyUnit" }, [
                          _c("span", [_vm._v("亿")]),
                          _c("span", [_vm._v("千")]),
                          _c("span", [_vm._v("百")]),
                          _c("span", [_vm._v("十")]),
                          _c("span", [_vm._v("万")]),
                          _c("span", [_vm._v("千")]),
                          _c("span", [_vm._v("百")]),
                          _c("span", [_vm._v("十")]),
                          _c("span", [_vm._v("元")]),
                          _c("span", [_vm._v("角")]),
                          _c("span", { staticClass: "last" }, [_vm._v("分")]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c(
                    "tbody",
                    [
                      _vm._l(_vm.form.items, function (it, index) {
                        return _c(
                          "tr",
                          { key: it.k, staticClass: "trDetails" },
                          [
                            _c(
                              "td",
                              {
                                staticClass: "tdZhaoyao tdInput",
                                staticStyle: { position: "relative" },
                              },
                              [
                                _vm.isEdit
                                  ? _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: it.summary,
                                          expression: "it.summary",
                                        },
                                      ],
                                      staticClass: "cell-input",
                                      attrs: { placeholder: "输入摘要" },
                                      domProps: { value: it.summary },
                                      on: {
                                        focus: function ($event) {
                                          return _vm.openSummaryDrop(
                                            it,
                                            index,
                                            $event
                                          )
                                        },
                                        blur: function ($event) {
                                          return _vm.handleSummaryBlur(it)
                                        },
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            it,
                                            "summary",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    })
                                  : _c(
                                      "div",
                                      { staticClass: "cell-click-display" },
                                      [_vm._v(_vm._s(it.summary || ""))]
                                    ),
                                _vm.isEdit
                                  ? _c(
                                      "i",
                                      {
                                        staticClass: "row-icon row-add",
                                        on: {
                                          click: function ($event) {
                                            return _vm.insertRow(index)
                                          },
                                        },
                                      },
                                      [
                                        _c("a-icon", {
                                          attrs: { type: "plus-circle" },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _c(
                              "td",
                              {
                                staticClass: "tdKemu tdInput",
                                staticStyle: { position: "relative" },
                              },
                              [
                                _vm.isEdit
                                  ? _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: it._subjectDisplayText,
                                          expression: "it._subjectDisplayText",
                                        },
                                      ],
                                      staticClass: "cell-input",
                                      attrs: {
                                        placeholder: "输入科目编码/名称",
                                      },
                                      domProps: {
                                        value: it._subjectDisplayText,
                                      },
                                      on: {
                                        focus: function ($event) {
                                          return _vm.openSubjectDrop(
                                            it,
                                            index,
                                            $event
                                          )
                                        },
                                        blur: function ($event) {
                                          return _vm.handleSubjectBlur(it)
                                        },
                                        input: [
                                          function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              it,
                                              "_subjectDisplayText",
                                              $event.target.value
                                            )
                                          },
                                          function ($event) {
                                            return _vm.filterSubject(it)
                                          },
                                        ],
                                      },
                                    })
                                  : _c(
                                      "div",
                                      {
                                        staticClass: "display subject-display",
                                      },
                                      [_vm._v(_vm._s(_vm.subjectText(it)))]
                                    ),
                              ]
                            ),
                            _c("td", { staticClass: "tdJieFang tdInput" }, [
                              it.editField !== "debit"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "display displayMoney",
                                      class: {
                                        "amount-negative":
                                          Number(it.debitAmount) < 0,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.startEdit(it, "debit")
                                        },
                                      },
                                    },
                                    _vm._l(
                                      _vm.amountDigits(it.debitAmount),
                                      function (d, i) {
                                        return _c(
                                          "span",
                                          {
                                            key: i,
                                            staticClass: "money-digit",
                                            class: { last: i === 10 },
                                          },
                                          [_vm._v(_vm._s(d))]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _c("input", {
                                    directives: [
                                      { name: "focus", rawName: "v-focus" },
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: it.debitAmount,
                                        expression: "it.debitAmount",
                                      },
                                    ],
                                    staticClass: "money-edit",
                                    attrs: { type: "text" },
                                    domProps: { value: it.debitAmount },
                                    on: {
                                      blur: function ($event) {
                                        return _vm.endEdit(it, "debit")
                                      },
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        return _vm.endEdit(it, "debit")
                                      },
                                      click: function ($event) {
                                        $event.stopPropagation()
                                      },
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          it,
                                          "debitAmount",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                            ]),
                            _c(
                              "td",
                              {
                                staticClass: "tdLast tdDaiFang tdInput",
                                staticStyle: { position: "relative" },
                              },
                              [
                                it.editField !== "credit"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "display displayMoney",
                                        class: {
                                          "amount-negative":
                                            Number(it.creditAmount) < 0,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.startEdit(it, "credit")
                                          },
                                        },
                                      },
                                      _vm._l(
                                        _vm.amountDigits(it.creditAmount),
                                        function (d, i) {
                                          return _c(
                                            "span",
                                            {
                                              key: i,
                                              staticClass: "money-digit",
                                              class: { last: i === 10 },
                                            },
                                            [_vm._v(_vm._s(d))]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _c("input", {
                                      directives: [
                                        { name: "focus", rawName: "v-focus" },
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: it.creditAmount,
                                          expression: "it.creditAmount",
                                        },
                                      ],
                                      staticClass: "money-edit",
                                      attrs: { type: "text" },
                                      domProps: { value: it.creditAmount },
                                      on: {
                                        blur: function ($event) {
                                          return _vm.endEdit(it, "credit")
                                        },
                                        keyup: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          )
                                            return null
                                          return _vm.endEdit(it, "credit")
                                        },
                                        click: function ($event) {
                                          $event.stopPropagation()
                                        },
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            it,
                                            "creditAmount",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                _vm.isEdit && _vm.form.items.length > 1
                                  ? _c(
                                      "i",
                                      {
                                        staticClass: "row-icon row-del",
                                        on: {
                                          click: function ($event) {
                                            return _vm.delRow(index)
                                          },
                                        },
                                      },
                                      [
                                        _c("a-icon", {
                                          attrs: { type: "minus-circle" },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        )
                      }),
                      _c("tr", { staticClass: "trDetails total" }, [
                        _c(
                          "td",
                          {
                            staticClass: "spTotal padding-left",
                            attrs: { colspan: "2" },
                          },
                          [_vm._v("合计:")]
                        ),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "display displayMoney",
                              class: { "amount-negative": _vm.debitTotal < 0 },
                            },
                            _vm._l(
                              _vm.amountDigits(_vm.debitTotal),
                              function (d, i) {
                                return _c(
                                  "span",
                                  {
                                    key: i,
                                    staticClass: "money-digit",
                                    class: { last: i === 10 },
                                  },
                                  [_vm._v(_vm._s(d))]
                                )
                              }
                            ),
                            0
                          ),
                        ]),
                        _c("td", { staticClass: "tdLast" }, [
                          _c(
                            "div",
                            {
                              staticClass: "display displayMoney",
                              class: { "amount-negative": _vm.creditTotal < 0 },
                            },
                            _vm._l(
                              _vm.amountDigits(_vm.creditTotal),
                              function (d, i) {
                                return _c(
                                  "span",
                                  {
                                    key: i,
                                    staticClass: "money-digit",
                                    class: { last: i === 10 },
                                  },
                                  [_vm._v(_vm._s(d))]
                                )
                              }
                            ),
                            0
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                ]),
              ]),
              _c("div", { staticClass: "voucher-footer" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "right",
                      color: "#999",
                      "padding-right": "20px",
                    },
                  },
                  [_vm._v("制单人：" + _vm._s(_vm.makerName || "当前用户"))]
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm.dropState.showSummary || _vm.dropState.showSubject
        ? _c(
            "div",
            {
              staticClass: "drop-panel-root",
              style: _vm.dropState.panelStyle,
              on: {
                mousedown: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _vm.dropState.showSummary
                ? _vm._l(_vm.summaryFilterList, function (opt) {
                    return _c(
                      "div",
                      {
                        key: opt,
                        staticClass: "drop-item",
                        on: {
                          click: function ($event) {
                            return _vm.selectSummaryItem(
                              _vm.dropState.currentRowItem,
                              opt
                            )
                          },
                        },
                      },
                      [_vm._v("\n        " + _vm._s(opt) + "\n      ")]
                    )
                  })
                : _vm._e(),
              _vm.dropState.showSubject
                ? _vm._l(_vm.subjectFilterList, function (s) {
                    return _c(
                      "div",
                      {
                        key: s.id,
                        staticClass: "drop-item",
                        on: {
                          click: function ($event) {
                            return _vm.selectSubjectItem(
                              _vm.dropState.currentRowItem,
                              s
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(s.subjectCode) +
                            " " +
                            _vm._s(s.subjectName) +
                            "\n      "
                        ),
                      ]
                    )
                  })
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _c(
        "a-modal",
        {
          attrs: {
            title: "辅助核算",
            width: 460,
            visible: _vm.auxVisible,
            maskClosable: false,
          },
          on: {
            ok: _vm.confirmAux,
            cancel: function ($event) {
              _vm.auxVisible = false
            },
          },
        },
        [
          _c(
            "a-form",
            { attrs: { layout: "horizontal" } },
            _vm._l(_vm.auxDialog.categories, function (c) {
              return _c(
                "a-form-item",
                { key: c.id, attrs: { label: c.name } },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.auxDialog.values[c.id],
                        callback: function ($$v) {
                          _vm.$set(_vm.auxDialog.values, c.id, $$v)
                        },
                        expression: "auxDialog.values[c.id]",
                      },
                    },
                    _vm._l(_vm.auxDialog.details[c.id], function (d) {
                      return _c(
                        "a-select-option",
                        { key: d.id, attrs: { value: d.id } },
                        [_vm._v(_vm._s(d.name))]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }